import './NoResultPopup.scss';
import { useAtomValue } from 'jotai';
import type { PopupOptions } from 'maplibre-gl';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MapPopup } from '@/features/map';
import { isEmpty } from '../model/result';
import { resultAtom, statusAtom } from '../state/atoms';

// Above the default origin pin (~35px tall), so the tip points at its head.
const PIN_OFFSET: PopupOptions['offset'] = [0, -38];

const OPTIONS: PopupOptions = {
  closeOnClick: false,
  offset: PIN_OFFSET,
  className: 'no-result',
  maxWidth: '230px',
};

/** Explains, next to the origin marker, why there is no result; the × hides it until the next result. */
export function NoResultPopup() {
  const { t } = useTranslation('glide');
  const result = useAtomValue(resultAtom);
  const status = useAtomValue(statusAtom);
  const [dismissed, setDismissed] = useState<typeof result>(null);
  if (!result || status.kind !== 'done' || !isEmpty(result) || result === dismissed) return null;

  return (
    <MapPopup
      lng={result.origin.lng}
      lat={result.origin.lat}
      open
      options={OPTIONS}
      onClose={() => setDismissed(result)}
    >
      <p className="pr-6 text-sm leading-snug">{t(`noResult.${result.mode}`, { gr: result.glideRatio })}</p>
    </MapPopup>
  );
}
